import type { HeroData, SpineAsset } from './types';

export type BannerLive2dSlot = {
  id: string;
  name: string;
  side: 'left' | 'right' | 'center';
  portrait: SpineAsset;
  fallback: string;
};

/** Lean hero payload for homepage banner Live2D (same source as catalog). */
export type BannerHeroSource = {
  id: string;
  gameId: string;
  name: string;
  latin: string;
  head: string;
  card?: string;
  kicker: string;
  stars: number;
  theme: string;
  traits: HeroData['traits'];
  quotes: string[];
  forms: Array<{
    portrait?: SpineAsset;
    fallback?: string;
    head?: string;
  }>;
};

export function catalogHeroesForBanner(heroes: HeroData[]): BannerHeroSource[] {
  return heroes
    .filter((hero) => hero.forms.some((form) => !!form.portrait))
    .map((hero) => {
      const form = hero.forms.find((item) => item.portrait) || hero.forms[0];
      return {
        id: hero.id,
        gameId: hero.gameId,
        name: hero.name,
        latin: hero.latin,
        head: hero.head,
        card: hero.card,
        kicker: hero.kicker,
        stars: hero.stars,
        theme: hero.theme,
        traits: hero.traits,
        quotes: hero.quotes || [],
        forms: form
          ? [
              {
                portrait: form.portrait,
                fallback: form.fallback,
                head: form.head,
              },
            ]
          : [],
      };
    });
}

/** Prefer featured ids when they have Live2D; otherwise first catalog hero with portrait. */
export function bannerSlotsFromCatalog(
  heroes: BannerHeroSource[],
  preferredIds: string[] = [],
): BannerLive2dSlot[] {
  const pick =
    preferredIds
      .map((id) => heroes.find((hero) => hero.id === id))
      .find((hero): hero is BannerHeroSource => Boolean(hero?.forms[0]?.portrait)) ||
    heroes.find((hero) => hero.forms[0]?.portrait);

  if (!pick?.forms[0]?.portrait) return [];
  const form = pick.forms[0];
  return [
    {
      id: pick.id,
      name: pick.name,
      side: 'right',
      portrait: form.portrait!,
      fallback: form.fallback ?? form.head ?? pick.head,
    },
  ];
}
